import Head from 'next/head';
import user from '../../src/services/api/user';
import pricesApi from '../../src/services/api/prices';

import Garanties from '../../src/components/assurance/Garanties';
import SupportForm from '../../src/components/common/elements/SupportForm';

import { baseUrlOf } from '../../src/lib/ssr';

const TITLE = "YUPWEGO - L'assurance dont vous êtes le héros";
const DESCRIPTION = `L'assurance voyage flexible et sans contraintes`;

const HREF = '/assurance/garanties';

const garanties = ({ profile, currentUrl, aCountries, cCountries }) => (
  <>
    <Head>
      <title key="title">{TITLE}</title>
      <meta key="og:type" content="page" property="og:type" />
      <meta key="og:title" content={TITLE} property="og:title" />
      <meta
        key="og:description"
        content="L'assurance voyage flexible et sans contraintes"
        property="og:description"
      />
      <meta key="og:url" content={currentUrl} property="og:url" />
      <meta key="twitter:card" name="twitter:card" content="summary" />
      <meta key="twitter:title" name="twitter:title" content={TITLE} />
      <meta
        key="twitter:description"
        name="twitter:description"
        content={DESCRIPTION}
      />
    </Head>
    <Garanties
      profile={profile}
      aCountries={aCountries}
      cCountries={cCountries}
    />
    <SupportForm />
  </>
);

garanties.getInitialProps = async ({ req, res }) => {
  const currentUrl = `${baseUrlOf(req)}/assurance`;
  const [profile, prices] = await Promise.all([
    user.profile(req, res),
    pricesApi.get(req)
  ]);
  const aCountries = Object.entries(prices.overrides)
    .filter(([, value]) => value.zone === 'A')
    .map(([key]) => key)
    .sort();
  const cCountries = Object.entries(prices.overrides)
    .filter(([, value]) => value.zone === 'C')
    .map(([key]) => key)
    .sort();
  return {
    profile,
    aCountries,
    cCountries,
    currentUrl
  };
};

export default garanties;
export { HREF };
